import React from 'react';
import styles from './sticky-element.scss';
import { throttle } from 'lodash';
import boundingBoxClientRect from 'bounding-client-rect';
import { findDOMNode } from 'react-dom';

// Digital has a sticky header so we need to trigger the translate a bit sooner.
const STICKY_HEADER_HEIGHT = 55;

class StickyElement extends React.Component {
  constructor() {
    super();
    this.state = {
      pageY: 0,
    };
    this.handleScroll = throttle(this.handleScroll, 0).bind(this);
  }

  handleScroll(event) {
    if (!event || !event.srcElement) return;

    if (!event.srcElement.documentElement && !event.srcElement.scrollingElement)
      return;

    const scrollingElement =
      event.srcElement.scrollingElement || event.srcElement.documentElement;

    const scrollTop = scrollingElement.scrollTop;
    const positionY =
      scrollTop + STICKY_HEADER_HEIGHT - this.containerBounds.top;
    const direction = positionY < this.state.pageY ? 'up' : 'down';
    const stickyContentBottom =
      this.stickyContentBounds.height +
      this.state.pageY +
      this.stickyContentBounds.top +
      200;

    if (
      direction === 'down' &&
      this.containerBounds.bottom < stickyContentBottom
    )
      return;

    if (
      scrollTop + STICKY_HEADER_HEIGHT < this.containerBounds.top ||
      this.containerBounds.top < 0
    ) {
      this.setState({
        pageY: 0,
      });
    } else {
      this.setState({
        pageY: positionY,
      });
    }
  }

  componentDidMount() {
    this.containerBounds = boundingBoxClientRect(
      document.getElementById('digitalRightContainer')
    );
    this.stickyContentBounds = boundingBoxClientRect(
      findDOMNode(this.refs.stickyContent)
    );

    window.addEventListener('scroll', this.handleScroll);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  render() {
    return (
      <div
        style={{
          transform: `translateY(${this.state.pageY}px)`,
        }}
        className={styles.stickyElement}
        ref="stickyContent"
      >
        {this.props.children}
      </div>
    );
  }
}

export default StickyElement;



// WEBPACK FOOTER //
// ./src/components/sticky-element/sticky-element.js